import React from 'react';
import { Button, type ButtonProps as AntButtonProps } from 'antd';
import styled from 'styled-components';

import RightIcon from '../../assets/right-arrow.svg';
import { LARGE_FIELD } from './constants';

const largeStyles = `
  height: ${LARGE_FIELD.height}px;
  font-size: ${LARGE_FIELD.fontSize}px;
  font-weight: 600;
  padding-left: 24px;
  padding-right: 24px;
`;

interface StyledButtonProps {
  $fullWidth?: boolean;
  $large?: boolean;
}

const StyledButton = styled(Button)<StyledButtonProps>`
  ${({ $fullWidth }) => $fullWidth && 'width: 100%;'}
  ${({ $large }) => $large && largeStyles}

  & .ant-btn-icon,
  & span {
    display: inline-flex;
    align-items: center;
  }
`;

interface ArrowIconProps {
  $white?: boolean;
  $flip?: boolean;
}

const ArrowIcon = styled.span<ArrowIconProps>`
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  background-color: ${({ $white, theme }) => ($white ? '#fff' : theme.primary)};
  mask-image: url(${RightIcon});
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  ${({ $flip }) => $flip && 'transform: rotate(180deg);'}
`;

interface FormButtonProps extends Omit<AntButtonProps, 'size'> {
  size?: 'large' | 'middle' | 'small';
  fullWidth?: boolean;
  withRightArrow?: boolean;
  withLeftArrow?: boolean;
}

function FormButton({
  size = 'large',
  fullWidth,
  withRightArrow,
  withLeftArrow,
  type,
  variant,
  children,
  ...props
}: FormButtonProps) {
  const isWhiteArrow = type === 'primary';

  const icon =
    withRightArrow || withLeftArrow ? (
      <ArrowIcon $white={isWhiteArrow} $flip={withLeftArrow} />
    ) : undefined;

  return (
    <StyledButton
      $large={size === 'large'}
      $fullWidth={fullWidth}
      type={type}
      variant={variant}
      icon={icon}
      iconPlacement={
        withLeftArrow ? 'start' : withRightArrow ? 'end' : undefined
      }
      {...props}
    >
      {children}
    </StyledButton>
  );
}

export default FormButton;
